import { useDeliveryOrPickupTagInfo } from '@/SearchResults/ResultTile/hooks';
import {
  getIsPreOrder,
  getPurchaseStatus,
  maybeHasGreatDealTag
} from '@/SearchResults/ResultTile/ResultTile.helpers';
import { useVehicleContext } from '~/contexts/VehicleContext';
import usePriceDrop from '~/hooks/usePriceDrop';
import GreatDealTag from './GreatDealTag';
import NewPriceTag from './NewPriceTag';
import OnHoldTag from './OnHoldTag';
import Tag from './Tag';

const Tags = () => {
  const { showTag: showAvailabilityTag, textToDisplay } =
    useDeliveryOrPickupTagInfo();
  const { vehicle } = useVehicleContext();
  const showPreOrderTag = getIsPreOrder(vehicle);
  const showGreatDeal = maybeHasGreatDealTag(vehicle);
  const { isLocked: showLockedTag, isOnHold: showOnHoldTag } =
    getPurchaseStatus(vehicle);
  const { getPriceDrop } = usePriceDrop();
  const { showPriceDrop } = getPriceDrop(vehicle);

  return (
    <div className="absolute flex gap-4 left-[8px] top-[8px]">
      {showOnHoldTag && <OnHoldTag />}
      {showPreOrderTag && <Tag text="Pre-Order Now" bgColor="bg-blue-2" />}
      {showLockedTag && (
        <Tag
          text="Purchase in Progress"
          bgColor="bg-red-2"
          data-qa="text-only-locked"
        />
      )}
      {showPriceDrop && <NewPriceTag />}
      {showGreatDeal && <GreatDealTag withPriceDrop={showPriceDrop} />}
      {showAvailabilityTag && (
        <Tag
          text={textToDisplay}
          data-qa="days-to-delivery-tag"
          border
          blueText
          bgColor="bg-white"
        />
      )}
    </div>
  );
};

export default Tags;
